import { UPDATE_TASK, UPDATE_TASK_SUCCESSFUL, UPDATE_TASK_FAILED } from './actionTypes';

const initialState = {
    updateTaskError: null, messageTask: null, loadingUpdateTask: false
}

const updateTask = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_TASK:
            state = {
                ...state,
                loadingUpdateTask: true,
                updateTaskError: null
            }
            break;
        case UPDATE_TASK_SUCCESSFUL:
            state = {
                ...state,
                loadingUpdateTask: false,
                messageTask: action.payload,
                updateTaskError: null
            }
            break;
        case UPDATE_TASK_FAILED:
            state = {
                ...state,
                messageTask: null,
                loadingUpdateTask: false,
                updateTaskError: action.payload
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default updateTask;